import { Button, ModalWindow, UIHeading2, useDeviceType } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './DeleteMessageModal.css';
// @ts-expect-error TODO: исправить импорт картинок
import questionImg from './assets/question.png';
import { EDeviceType } from '../../types/deviceType';

interface IDeleteMessageModalProps {
  onClose(): void;
  onDelete(): void;
}

export const DeleteMessageModal: React.FC<IDeleteMessageModalProps> = ({ onClose, onDelete }) => {
  const isMobile = useDeviceType() === EDeviceType.Phone;

  const content = React.useMemo(() => {
    if (isMobile) {
      return <div />;
    }

    return (
      <div className={styles['container']}>
        <img width="64px" height="64px" src={questionImg} alt="delete" />
        <UIHeading2 textAlign="center">Вы действительно хотите удалить сообщение?</UIHeading2>
      </div>
    );
  }, [isMobile]);

  return (
    <ModalWindow
      open={true}
      onClose={onClose}
      width={505}
      title={isMobile ? 'Точно хотите удалить сообщение?' : undefined}
      footer={
        <div className={classNames(styles['footer'], isMobile && styles['mobile'])}>
          <Button
            onClick={onClose}
            size={isMobile ? 'M' : 'L'}
            theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
          >
            Отмена
          </Button>
          <Button onClick={onDelete} size={isMobile ? 'M' : 'L'} theme="fill_primary">
            Удалить
          </Button>
        </div>
      }
    >
      {content}
    </ModalWindow>
  );
};
